<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 80px"
                >
                  <a-select-option value="name"> Name </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>

          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                v-model="table.filters.status_code"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null"> All </a-radio>
                <a-radio :style="radio.style" value="A"> Active </a-radio>
                <a-radio :style="radio.style" value="I"> Inactive </a-radio>
              </a-radio-group>
            </div>
          </div>
          <hr />
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              v-if="selectedActions.includes('Add')"
              >+ Add Membership Program</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <MembershipProgramForm
                :viewMode="viewMode"
                :membershipProgramData="membershipProgramData"
                :drawerVisible="drawer.visible"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              class="btn btn-success btn-sm"
              v-if="selectedActions.includes('View')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
            <button
              id="edit"
              class="btn btn-warning btn-sm"
              v-if="selectedActions.includes('Edit')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import MembershipProgramForm from './MembershipProgramFormV2.vue';
import { mapGetters } from 'vuex';
import secureStorage from '../../controllers/secureStorage';
import tokenHandler from '../../controllers/token';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    MembershipProgramForm
  },
  data() {
    return {
      // selectedActions: [],
      gradientType: 'gradient-orange',
      membershipProgramData: null,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Membership Programs',
        apiUrl: '/api/v1/clp_membership_programs',
        fields: [
          'actions',
          'name',
          { name: 'member_number_from', title: 'Member Number From' },
          { name: 'member_number_to', title: 'Member Number To' }
        ],
        filters: {
          name: null,
          status_code: null
        },
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.membershipProgramData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.membershipProgramData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    }
  },
  created() {
    this.$store.dispatch('setCurrentModule', 'MembershipProgramV2');
  },
  async mounted() {
    // this.selectedActions = this.$store.getters.getModuleSelectedActions;
    if (secureStorage.getItem('uploadToken') === null) {
      await tokenHandler.refreshS3Token();
    }
  }
};
</script>

<style scoped></style>
